import { RouteObject } from 'react-router-dom';
import { HomePage } from '@pages/home';

export enum AppRoutes {
    Home = '/widget',
}

export const routes: RouteObject[] = [
    {
        path: AppRoutes.Home,
        element: <HomePage />,
    },
];
